<sw-page class="riccardo-deal-detail">
    <template #smart-bar-header>
        <h2>{{ deal?.name || $t('riccardo-deal.detail.titleNew') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button :router-link="{ name: 'riccardo.deal.list' }">{{ $t('global.default.cancel') }}</sw-button>
        <sw-button-process variant="primary" :is-loading="isLoading" :process-success="isSaveSuccessful" @click="onSave">
            {{ $t('global.default.save') }}
        </sw-button-process>
    </template>

    <template #content>
        <sw-card-view v-if="deal">
            <sw-card :title="$t('riccardo-deal.detail.cardGeneral')" :is-loading="isLoading">
                <sw-switch-field v-model:value="deal.active" :label="$t('riccardo-deal.detail.active')" />
                <sw-text-field v-model:value="deal.name" :label="$t('riccardo-deal.detail.name')" required />
                <sw-text-field v-model:value="deal.badge" :label="$t('riccardo-deal.detail.badge')" :help-text="$t('riccardo-deal.detail.badgeHelp')" />
                <sw-entity-single-select
                    v-model:value="deal.productId"
                    entity="product"
                    :criteria="productCriteria"
                    label-property="translated.name"
                    :label="$t('riccardo-deal.detail.product')"
                    :help-text="$t('riccardo-deal.detail.productHelp')"
                    required
                />
            </sw-card>

            <sw-card :title="$t('riccardo-deal.detail.cardPrice')" :is-loading="isLoading">
                <sw-container columns="1fr 1fr 1fr" gap="0 24px">
                    <sw-single-select v-model:value="deal.priceType" :options="priceTypeOptions" :label="$t('riccardo-deal.detail.priceType')" />
                    <sw-number-field v-model:value="deal.priceValue" number-type="float" :min="0" :digits="2" :label="deal.priceType === 'percent' ? $t('riccardo-deal.detail.pricePercent') : $t('riccardo-deal.detail.priceFixed')" />
                    <sw-number-field v-model:value="deal.maxQuantity" number-type="int" :min="1" :label="$t('riccardo-deal.detail.maxQuantity')" />
                </sw-container>
            </sw-card>

            <sw-card :title="$t('riccardo-deal.detail.cardCondition')" :is-loading="isLoading">
                <sw-container columns="1fr 1fr" gap="0 24px">
                    <sw-number-field v-model:value="deal.minQualifyingValue" number-type="float" :min="0" :digits="2" :label="$t('riccardo-deal.detail.minQualifyingValue')" :help-text="$t('riccardo-deal.detail.minQualifyingValueHelp')" />
                    <sw-text-field v-model:value="deal.qualifyingLabel" :label="$t('riccardo-deal.detail.qualifyingLabel')" :help-text="$t('riccardo-deal.detail.qualifyingLabelHelp')" />
                </sw-container>
                <sw-entity-multi-select
                    v-model:entity-collection="deal.qualifyingCategories"
                    :label="$t('riccardo-deal.detail.qualifyingCategories')"
                    :help-text="$t('riccardo-deal.detail.qualifyingCategoriesHelp')"
                    label-property="translated.name"
                />
                <sw-number-field v-model:value="deal.minMargin" number-type="float" :min="0" :max="100" :digits="1" :label="$t('riccardo-deal.detail.minMargin')" :help-text="$t('riccardo-deal.detail.minMarginHelp')" />
                <sw-single-select v-model:value="deal.behavior" :options="behaviorOptions" :label="$t('riccardo-deal.detail.behavior')" :help-text="$t('riccardo-deal.detail.behaviorHelp')" />
                <sw-alert variant="info">{{ summary }}</sw-alert>
            </sw-card>

            <sw-card :title="$t('riccardo-deal.detail.cardPeriod')" :is-loading="isLoading">
                <sw-container columns="1fr 1fr 1fr" gap="0 24px">
                    <sw-datepicker v-model:value="deal.validFrom" date-type="datetime" :label="$t('riccardo-deal.detail.validFrom')" />
                    <sw-datepicker v-model:value="deal.validUntil" date-type="datetime" :label="$t('riccardo-deal.detail.validUntil')" />
                    <sw-number-field v-model:value="deal.priority" number-type="int" :label="$t('riccardo-deal.detail.priority')" :help-text="$t('riccardo-deal.detail.priorityHelp')" />
                </sw-container>
            </sw-card>
        </sw-card-view>
    </template>
</sw-page>
